<template>
    <b-modal v-model="show" :no-close-on-esc="true" :no-close-on-backdrop="true" size="xl">
      <h4 class="text-center mt-0"><b>{{$t("auto.comparative")}}</b></h4>
      <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card card-form">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12" style="min-height: 500px">
                                  <div class="table-wrapper">
                                    <table class="table table-bordered" v-if="autoData.kossApiResponseDto && autoData.kossApiResponseDto.autoDataApiList && autoData.kossApiResponseDto.autoDataApiList.length > 0">
                                        <tr>
                                            <td align="center" class="align-middle"><b><i>№</i></b></td>
                                            <td align="center" class="align-middle"><b><i>Кўрсаткичлар</i></b>
                                            </td>
                                            <td align="center" class="align-middle"><b><i>Тузатиш
                                                элементлари</i></b></td>
                                            <td align="center" class="align-middle"><b><i>Баҳолаш объекти</i></b>
                                            </td>
                                            <td colspan="3" align="center"><b><i>Такослаш объекти (аналоги)</i></b></td>
                                        </tr>
                                        <tr>
                                            <td colspan="7" align="center"><b><i>I. Бўлим: Бозорни тадкик килиш, аналог
                                                обектлар бўйича ахборотни тахлил килиш ва йиғиш</i></b></td>
                                        </tr>
                                        <tr>
                                            <td colspan="7" align="center"><b><i>1,1 Аналог объектларга доир битимлар
                                                (таклифлар) тўғрисида ахборот олиш максадида тадкик килиш.</i></b></td>
                                        </tr>
                                        <tr style="height: 200px;">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td align="center">
                                                <label>Анолог</label>
                                                <v-select v-model="analog1" label="text"
                                                          style="height: 100px;width: 250px"
                                                          :options="analogs"
                                                          :filterable="false">
                                                    <template slot="option" slot-scope="option" v-if="option">
                                                        <div v-html="option.text"></div>
                                                    </template>
                                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                </v-select>
                                            </td>
                                            <td align="center"><label>Анолог</label>
                                                <v-select v-model="analog2" label="text"
                                                          :options="analogs"
                                                          style="height: 100px;width: 250px"
                                                          :filterable="false"
                                                          >
                                                    <template slot="option" slot-scope="option" v-if="option">
                                                        <div v-html="option.text"></div>
                                                    </template>
                                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                </v-select>
                                            </td>
                                            <td align="center"><label>Анолог</label>
                                                <v-select v-model="analog3" label="text"
                                                          :options="analogs"
                                                          style="height: 100px;width: 250px"
                                                          :filterable="false">
                                                    <template slot="option" slot-scope="option" v-if="option">
                                                        <div v-html="option.text"></div>
                                                    </template>
                                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                </v-select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center"><b><i>1,1,1</i></b></td>
                                            <td align="center"><b><i>Аналоглар</i></b></td>
                                            <td></td>
                                            <td></td>
                                            <td align="center"><b><i>Анолог 1</i></b></td>
                                            <td align="center"><b><i>Анолог 2</i></b></td>
                                            <td align="center"><b><i>Анолог 3</i></b></td>
                                        </tr>
                                        <tr>
                                            <td align="center"><b><i>1,1,2</i></b></td>
                                            <td align="center"><b><i>Русуми</i></b></td>
                                            <td></td>
                                            <td align="center" class="align-middle font-weight-bold">
                                                {{autoData.name}}
                                            </td>
                                            <td align="center" class="align-middle font-weight-bold" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].name}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center"><b><i>1,1,3</i></b></td>
                                            <td align="center" class="font-weight-bold">Позицияси</td>
                                            <td></td>
                                            <td align="center" class="align-middle font-weight-bold">
                                                {{autoData.autoTypeDto.position}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].position}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center"><b><i>1,1,4</i></b></td>
                                            <td align="center" class="font-weight-bold">Ишлаб чиқарилган йили</td>
                                            <td></td>
                                            <td align="center" class="align-middle font-weight-bold">
                                                {{autoData.madeYear}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].productionYear}}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="2"
                                                class="align-middle font-weight-bold"><b><i>1,1,5</i></b>
                                            </td>
                                            <td align="center" rowspan="2"
                                                class="align-middle font-weight-bold">Маълумотлар баъзасида
                                                сакланаган ва Фойдаланилган манба
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].foreignCar
                                                ? "Хорижий" : "Махалий"}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].source}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center"><b><i>1,1,6</i></b></td>
                                            <td align="center" class="font-weight-bold">Маълумотлар баъзасидаги
                                                Манбанинг эълон рақами ва хаволаси
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].link}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center"><b><i>1,1,7</i></b></td>
                                            <td align="center" class="font-weight-bold">Сотишга таклиф қилинган ёки
                                                сотилган сана
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].sourceDate}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="7" align="center">
                                                <b>
                                                    <i>
                                                        1,2 Аналог объектларга доир битимлар (таклифлар) тўғрисида
                                                        ахборот олиш максадида тахлил килиш.
                                                    </i>
                                                </b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" class="align-middle"><b><i>1,2,1</i></b></td>
                                            <td align="center" class="font-weight-bold">Сотишга таклиф қилинган ёки
                                                сотилган санадаги АҚШ долларини ўзбек сўмига нисбатан курси Марказий
                                                банк эълон ставкасида
                                            </td>
                                            <td></td>
                                            <td align="center" class="align-middle font-weight-bold">
                                                <b>{{autoData.kossApiResponseDto.usdRate | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                            <td align="center" class="align-middle"
                                                v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].usdRate | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center"><b><i>1,2,2</i></b></td>
                                            <td align="center" class="font-weight-bold">
                                                Сотишга таклиф қилинган ёки сотилган санага нисбатан, Сотилиш баҳоси.
                                                АҚШ долларида
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td align="center" class="align-middle"
                                                v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].usdPrice | currency('', 2, { thousandsSeparator: ' ' })}} $</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center"><b><i>1,2,3</i></b></td>
                                            <td align="center" class="font-weight-bold">Сотишга таклиф қилинган ёки
                                                сотилган санага нисбатан Сотилиш бахоси.
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].uzsPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="2" class="align-middle">
                                                <b><i>1,2,4</i></b></td>
                                            <td align="center" rowspan="2"
                                                class="align-middle font-weight-bold">Шартномавий нархи
                                            </td>
                                            <td align="center">Транспорт харажати</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].transportation.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                                %
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Шартномавий нархи</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].transportation.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="6" class="align-middle">
                                                <b><i>1,2,5</i></b></td>
                                            <td align="center" rowspan="5"
                                                class="align-middle font-weight-bold">Импорт килишда
                                                соликлар ва йигимлар
                                            </td>
                                            <td align="center">Божхона божи</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.customs}}
                                                %
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Акциз</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.excise}}
                                                %
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">ҚҚС</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.vat}}
                                                %
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Божхона харажатлари</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.customsClearance}}
                                                %
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.taxCoefficient}}
                                                %
                                            </td>
                                        </tr>
                                        <tr align="center" class="align-middle">
                                            <td><b><i>Таклиф ёки сотилиш нархи</i></b></td>
                                            <td></td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.taxFixPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="7" align="center">
                                                <b>
                                                    <i>
                                                        2-Бўлим:Киёслаш бирликларини аниклаш
                                                    </i>
                                                </b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="7" align="center">
                                                <b>
                                                    <i>
                                                        2,1 Техник тавсифлар
                                                    </i>
                                                </b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>2,1,1</i></b></td>
                                            <td align="center" rowspan="3"
                                                class="align-middle font-weight-bold">Унумдорлиги ёки
                                                куввати (Двигател ҳажмига тузатиш)
                                            </td>
                                            <td align="center">Дивигател хажми</td>
                                            <td rowspan="3" align="center" class="align-middle">
                                                {{autoData.autoTypeDto.engineCapacity}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.value}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>2,1,2</i></b></td>
                                            <td align="center" rowspan="3"
                                                class="align-middle font-weight-bold">
                                                Юк кўтариши
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>2,1,3</i></b></td>
                                            <td align="center" rowspan="3"
                                                class="align-middle font-weight-bold">
                                                Юк тортиши
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>2,1,4</i></b></td>
                                            <td align="center" rowspan="3"
                                                class="align-middle font-weight-bold">
                                                Иш макони хажимлари
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>2,1,5</i></b></td>
                                            <td align="center" rowspan="3"
                                                class="align-middle font-weight-bold">
                                                Аниклик тоифаси
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>2,1,6</i></b></td>
                                            <td align="center" rowspan="3"
                                                class="align-middle font-weight-bold">
                                                Автоматлаштириш даражаси
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="7" align="center">
                                                <b>
                                                    <i>
                                                        2,2 Фойдаланиш тавсифлари
                                                    </i>
                                                </b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="4" class="align-middle">
                                                <b><i>2,2,1</i></b></td>
                                            <td align="center" rowspan="4"
                                                class="align-middle font-weight-bold">
                                                Автоматик, ярим автоматик, ёки ноавтаматик фойдаланилиши
                                            </td>
                                            <td></td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.gearBoxFix.name}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.name}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <!--<td align="center"></td>-->
                                            <!--<td align="center">-->
                                                <!--{{autoData.kossApiResponseDto.gearBoxFix.coefficient | currency('', 2, { thousandsSeparator: ' ' })}}-->
                                            <!--</td>-->
                                            <!--<td align="center" v-for="n in 3" :key="n">-->
                                                <!--{{autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.value |-->
                                                <!--currency('', 2, { thousandsSeparator: ' ' })}}-->
                                            <!--</td>-->
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td align="center">
                                                <!--{{autoData.kossApiResponseDto.gearBoxFix.coefficient | currency('', 2, { thousandsSeparator: ' ' })}}-->
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.coefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>2,2,2</i></b></td>
                                            <td align="center" rowspan="3"
                                                class="align-middle font-weight-bold">
                                                Тўхтовсиз ишлаши
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>2,2,3</i></b></td>
                                            <td align="center" rowspan="3"
                                                class="align-middle font-weight-bold">
                                                Чидамлилиги
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>2,2,4</i></b></td>
                                            <td align="center" rowspan="3"
                                                class="align-middle font-weight-bold">
                                                Таъмирга яроклилиги
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Ярокли
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>2,2,5</i></b></td>
                                            <td align="center" rowspan="3"
                                                class="align-middle font-weight-bold">
                                                Бут сакланганлиги
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Бут сакланган
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="7" align="center">
                                                <b>
                                                    <i>
                                                        2,3 Конструктив тавсифлар
                                                    </i>
                                                </b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>2,3,1</i></b></td>
                                            <td align="center" rowspan="3"
                                                class="align-middle font-weight-bold">
                                                Массаси
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="4" class="align-middle">
                                                <b><i>2,3,2</i></b></td>
                                            <td align="center" rowspan="4"
                                                class="align-middle font-weight-bold">
                                                Оғирлиги (Кг)
                                            </td>
                                            <td align="center">Ўлчов бирлиги</td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Килограм
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Оғирлиги</td>
                                            <td align="center">{{autoData.fullWeight}}</td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].weightFix.value}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].weightFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].weightFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="4" class="align-middle">
                                                <b><i>2,3,3</i></b></td>
                                            <td align="center" rowspan="4"
                                                class="align-middle font-weight-bold">
                                                Асосий конструктив материалларнинг таркиби
                                            </td>
                                            <td align="center">Позицияси</td>


                                            <td align="center" v-if="autoData.kossApiResponseDto.carPosition>0">
                                                {{autoData.kossApiResponseDto.carPosition}}
                                            </td>
                                            <td align="center" v-if="autoData.kossApiResponseDto.carPosition==0">
                                                Мавжуд эмас
                                            </td>

                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.name}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                Диллерлар томониданталиф килинаётган нарх
                                            </td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.newPriceUzs}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.value}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="7" align="center">
                                                <b>
                                                    <i>
                                                        2,4 Иқтисодий тавсифлар
                                                    </i>
                                                </b>
                                            </td>
                                        </tr>
                                        <tr v-if="autoData.fixByIndex">
                                            <td align="center" rowspan="4" class="align-middle">
                                                <b><i>2,4,1</i></b></td>
                                            <td align="center" rowspan="4"
                                                class="align-middle font-weight-bold">
                                                Машиналар вакт бирлигида
                                            </td>
                                            <td align="center">Ишлаб чикарилган йили</td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.madeYearFix.name}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.name}}
                                            </td>
                                        </tr>
                                        <tr v-if="autoData.fixByIndex">
                                            <td align="center">
                                                Махсулот нархлари киматлашишнинг Статистик индекс
                                            </td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.madeYearFix.value}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.value}}
                                            </td>
                                        </tr>
                                        <tr v-if="autoData.fixByIndex">
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr>
                                        <tr v-if="autoData.fixByIndex">
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b v-if="autoData.fixByIndex"><i>2,4,2</i></b>
                                                <b v-else><i>2,4,1</i></b>
                                            </td>
                                            <td align="center" rowspan="3"
                                                class="align-middle font-weight-bold">
                                                Махсулот ёки ишлар бирлигида фаолият кўрсатганда турли захиралар
                                                сарфланиши
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b v-if="autoData.fixByIndex">{{autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                                <b v-else >{{autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="7" align="center">
                                                <b>
                                                    <i>
                                                        3-Боб Киёслаш элементларини танлаш.
                                                    </i>
                                                </b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="7" align="center">
                                                <b>
                                                    <i>
                                                        3,1 Мулкий ҳуқуқлар
                                                    </i>
                                                </b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>3,1,1</i></b></td>
                                            <td align="center" rowspan="3"
                                                class="align-middle font-weight-bold">
                                                Сотилганда ўтадиган мулкий ҳуқуқлар
                                            </td>
                                            <td></td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.ownershipFix.name}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].ownershipFix.name}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.ownershipFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].ownershipFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].ownershipFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="7" align="center">
                                                <b>
                                                    <i>
                                                        3,2 Молиялаштириш шартлари
                                                    </i>
                                                </b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="4" class="align-middle">
                                                <b><i>3,2,1</i></b></td>
                                            <td align="center" rowspan="4"
                                                class="align-middle font-weight-bold">
                                                Молиялаштириш шартлари
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Тўлов тури
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Олдиндан тўлов
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td align="center">
                                                <!--{{autoData.kossApiResponseDto.financeFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}-->
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].financeFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].financeFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td v-if="autoData.fixByIndex" colspan="7" align="center">
                                                <b>
                                                    <i>
                                                        3,3 Бозор холати (Сотиш вакти)
                                                    </i>
                                                </b>
                                            </td>
                                        </tr>
                                        <tr v-if="autoData.fixByIndex">
                                            <td align="center" rowspan="4" class="align-middle">
                                                <b><i>3,3,1</i></b></td>
                                            <td align="center" rowspan="4"
                                                class="align-middle font-weight-bold">
                                                Аналог объектларга нархларнинг ўзгариши
                                            </td>
                                            <td align="center">Сотишга таклиф қилинган ёки сотилган сана</td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.saleDateFix.name}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.name}}
                                            </td>
                                        </tr>
                                        <tr v-if="autoData.fixByIndex">
                                            <td align="center">
                                                Махсулот нархлари киматлашишнинг Статистик индекс
                                            </td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.saleDateFix.value}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.value}}
                                            </td>
                                        </tr>
                                        <tr v-if="autoData.fixByIndex">
                                            <td align="center">Тузатиш</td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.saleDateFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr>
                                        <tr v-if="autoData.fixByIndex">
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr v-if="!autoData.fixByIndex">
                                            <td colspan="7" align="center">
                                                <b>
                                                    <i>
                                                        3,3 Бозор холати (Сотиш вакти)
                                                    </i>
                                                </b>
                                            </td>
                                        </tr>
                                        <tr v-if="!autoData.fixByIndex">
                                            <td align="center" rowspan="4" style="vertical-align: middle;">
                                                <b><i>3,3,1</i></b></td>
                                            <td align="center" rowspan="4"
                                                style="vertical-align: middle; font-weight: bold">
                                                Аналог объектларга нархларнинг ўзгариши
                                            </td>
                                            <td align="center">Сотишга таклиф қилинган ёки сотилган сана</td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.saleDateFix.name}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.name}}
                                            </td>
                                        </tr>
                                        <tr v-if="!autoData.fixByIndex">
                                            <td align="center">
                                                Махсулот нархлари киматлашишнинг Статистик индекс
                                            </td>
                                            <td align="center" style="vertical-align: middle;font-weight: bold">
                                                {{autoData.kossApiResponseDto.usdRate | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                            </td>
                                            <td align="center" style="vertical-align: middle"  v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.value | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                            </td>
                                        </tr>
                                        <tr v-if="!autoData.fixByIndex">
                                            <td align="center">Тузатиш</td>
                                            <td align="center"></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr>
                                        <tr v-if="!autoData.fixByIndex">
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="7" align="center">
                                                <b>
                                                    <i>
                                                        3,4 Сотиш шартлари
                                                    </i>
                                                </b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="19" class="align-middle">
                                                <b><i>3,4,1</i></b></td>
                                            <td align="center" rowspan="19"
                                                class="align-middle font-weight-bold">
                                                Сотувчи ва харидор ўртасидаги бозорга хос бўлмаган муносабатлар
                                            </td>
                                            <td align="center">Етказиб бершнинг тезлаштирилган муддати</td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                Тузатиш
                                            </td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b v-if="autoData.fixByIndex">{{autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                                <b v-else >{{autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Кафолат муддати (йилда)</td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                Тузатиш
                                            </td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b v-if="autoData.fixByIndex">{{autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                                <b v-else >{{autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center"><b>Чегирмалар</b></td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.name}}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                Тузатиш
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" class="align-middle"><b>Бутлаш</b></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                Тузатиш
                                            </td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" class="align-middle"><b>Қўшимча хизматлар</b>
                                            </td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                Тузатиш
                                            </td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="2" class="align-middle"><b>ҚҚС
                                                мавжудлиги</b></td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.vatFix.name}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                Мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.vatFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                                %
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].vatFix.value | currency('', 4, { thousandsSeparator: ' ' })}}
                                                %
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                Тузатиш
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].vatFix.coefficientFix | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].vatFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="7" align="center">
                                                <b>
                                                    <i>
                                                        3,5 Физик тавсифлар
                                                    </i>
                                                </b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="4" class="align-middle">
                                                <b><i>3,5,1</i></b>
                                            </td>
                                            <td align="center" rowspan="4"
                                                class="align-middle font-weight-bold">
                                                Техник холати (Эскириш фоизи)
                                            </td>
                                            <td align="center">Холати</td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.conditionFix.name}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.name ? autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.name : ''}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                Эскириш фоизи
                                            </td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.conditionFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                                %
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.value | currency('', 4, { thousandsSeparator: ' ' })}}
                                                %
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.conditionFix.value}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>3,5,2</i></b>
                                            </td>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>Жорий фойдаланиш хусусияти</i></b>
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>3,5,3</i></b>
                                            </td>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>Қўшимча бутланиш</i></b>
                                            </td>
                                            <td></td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                Маълумот мавжуд эмас
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td align="center" v-for="n in 4" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="7" align="center">
                                                <b>
                                                    <i>
                                                        3,6 Фойдаланиш шартлари
                                                    </i>
                                                </b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>3,6,1</i></b>
                                            </td>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>Жорий фойдаланиш хусусияти</i></b>
                                            </td>
                                            <td align="center">Ёкилғи тури</td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.fuelTypeFix.name}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].fuelTypeFix.name}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.fuelTypeFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].fuelTypeFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].fuelTypeFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>3,6,2</i></b>
                                            </td>
                                            <td align="center" rowspan="3" class="align-middle">
                                                <b><i>Функцианал фойдаланиш</i></b>
                                            </td>
                                            <td align="center"></td>
                                            <td align="center">
                                                {{autoData.kossApiResponseDto.autoType}}
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                {{autoData.kossApiResponseDto.autoDataApiList[n - 1].autoType}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатиш</td>
                                            <td align="center">
                                                1
                                            </td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                1
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">Тузатишдан кейинги киймат</td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].fuelTypeFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td align="center" class="align-middle font-weight-bold">
                                                Тузатишлар сони
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].totalComparativeFix.fixedCount}}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td align="center" class="align-middle font-weight-bold">
                                                Коффициент улушлари
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].totalComparativeFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td align="center" class="align-middle font-weight-bold">
                                                Тузатишларни киритгандан кейинги улушларни хисобга олгандаги бахоси
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td align="center" v-for="n in 3" :key="n">
                                                <b>{{autoData.kossApiResponseDto.autoDataApiList[n - 1].totalComparativeFix.fixedPrice | currency('', 2, { thousandsSeparator: ' ' })}}
                                                    сўм</b>
                                            </td>
                                        </tr>
                                    </table>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-right">
                    <b>Қиёсий ёндошув жами бахоси: <span class="text-success">{{autoData.kossApiResponseDto.govPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span></b>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn delete-btn float-left mr-2" @click="cancel">
                Бекор қилиш
            </button>
          <button class="all-btn add-btn float-right mr-2" @click="save">
            Сақлаш
          </button>
        </div>

    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {numericTypes} from '@/shared/constants/mask'

    export default {
        name: "ComparativeMutable",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                processing: false,
                numericTypes: numericTypes,
                show: false,
                analogList: [],
                analogs: [],
                ids: [],
                analog1: null,
                analog2: null,
                analog3: null,
                autoData: {
                    kossApiResponseDto: {}
                }
            }
        },
        methods: {
            init() {
                const vm = this;
                if (this.autoId && this.autoId > 0) {
                    this.$http.get('auto/item/' + this.autoId).then(function (data) {
                        vm.autoData = data.data;
                        for (var i = 0; i < vm.autoData.kossApiResponseDto.autoDataApiList.length; i++) {
                            vm.ids[i] = vm.autoData.kossApiResponseDto.autoDataApiList[i].id;
                        }
                    });
                }
            },
            save() {
                if (this.analog1 == null && this.analog2 == null && this.analog3 == null) {
                    // this.$swal({
                    //     title: this.$t('messages.common.error'),
                    //     text: "Kamida bitta analog tanlangan bo'lishi kerak",
                    //     type: 'error'
                    // });
                    this.$swal({
                        title: this.$t('messages.common.success'),
                        text: this.$t('messages.building.success'),
                        type: 'success'
                    });
                    this.show = false;
                } else {
                    if (this.analog1 != null) {
                        this.ids[0] = this.analog1.id;
                    }
                    if (this.analog2 != null) {
                        this.ids[1] = this.analog2.id;
                    }
                    if (this.analog3 != null) {
                        this.ids[2] = this.analog3.id;
                    }
                    this.loading = true;
                    this.$http.get('comparative_mutable-auto/comparative/analogs/save/' + this.autoId + '/' + this.ids.toString()).then(res => {
                        this.loading = false;
                        if (res.data) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.building.success'),
                                type: 'success'
                            });
                        }
                        this.show = false;
                        window.location.reload();
                    }, err => {
                        console.log(err);
                    });
                }
            },

            getComparativeAnalogs() {
                this.$http.get('comparative_mutable-auto/comparative/analogs/list/' + this.autoId)
                    .then(res => {
                        this.analogs = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            // onComparativeAnalogChange() {
            //     if (this.analogList && this.analogList.length===0) {
            //         this.getComparativeAnalogs();
            //     }
            //     this.analogs = this.analogList;
            // },
            cancel() {
                this.show = false;
            }
        },
        created() {
            this.$eventBus.$on('ComparativeMutable', (autoId) => {
                this.show = true;
                this.autoId = autoId;
                this.init();
                this.getComparativeAnalogs();
            });
        }
    }
</script>

<style>
    .modal-content {
        width: 100%;
    }
</style>